import { workspaceV1GetAdminConfigOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetAdminConfig = () => {
  const { workspace } = useWorkspace();
  return useQuery({
    ...workspaceV1GetAdminConfigOptions({
      ...defaultOptions(),
      path: { workspace },
    }),
  });
};
